import React, {useState, useEffect} from 'react'
import { GraphQLResult } from "@aws-amplify/api";
import { v4 as uuidv4 } from "uuid";
import { FaTrash } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import { API, graphqlOperation} from 'aws-amplify';
import { Button, Form } from "react-bootstrap";
import {
  currenciesResultType,
  currencyType,
} from "./CurrenciesType";
import "./Currencies.css";
import { Modal } from '../../Modal/Modal';
import { createCurrencies, deleteCurrencies } from "../../../graphql/mutations";
import { getCurrencies } from '../../../graphql/queries';
import { color } from '../../../styles/colors';


export const Currencies = () => {
  const [currencies, setCurrencies] = useState<
    Pick<
      currencyType,
      "id" | "CurrencyCode" 
      | "CurrencyName"
    >[]
  >([
    {
      id: "",
      CurrencyCode: "",
      CurrencyName: "",
    },
  ]);
  const [enableModal, setEnableModal] = useState<boolean>(false);
  const [currencyCode, setCurrencyCode] = useState<string>("");
  const [currencyName, setCurrencyName] = useState<string>("");
  const [currencyToDelete, setCurrencyToDelete] = useState<
    Pick<currencyType, "id" | "CurrencyName">
  >({
    id: "",
    CurrencyName: "",
  });
  const [enableDeleteModal, setEnableDeleteModal] = useState<boolean>(false);

  useEffect(() => {
    fetchCurrencies()
  }, []);

  const fetchCurrencies = async () => {
    try {
      const result = (await API.graphql(
        graphqlOperation(getCurrencies)
      )) as GraphQLResult<currenciesResultType>;
     const activeResults = result?.data?.getCurrencies;
     console.log("activeResults", activeResults);
      setCurrencies(activeResults);
    } catch(e) {
      console.log(e)
    }
  }
  
  const handleOpenModal = () => {
    setEnableModal(true)
  }

  const handleCloseModal = () => {
    setEnableModal(false)
  }

  const handleOpenDeleteModal = () => {
    setEnableDeleteModal(true)
  }

  const handleCloseDeleteModal = () => {
    setEnableDeleteModal(false)
  }

  const postCurrencies = async () => {
      const id = uuidv4();
      await API.graphql(
        graphqlOperation(createCurrencies, {
          currency: {
            id,
            CurrencyCode: currencyCode,
            CurrencyName: currencyName,
          },
        })
      );
      fetchCurrencies();
      handleCloseModal();
  };

  const handleDelete = async () => {
    await API.graphql(
      graphqlOperation(deleteCurrencies, {
        currencyId: currencyToDelete.id,
      })
    );
     fetchCurrencies();
     handleCloseDeleteModal();
  }

  const renderCurrencyInput = () => (
    <Form>
      <Form.Group controlId="formCurrencyCode">
        <Form.Label>Currency Code</Form.Label>
        <Form.Control
          size="lg"
          aria-label="Currency Code"
          onChange={(e) => setCurrencyCode(e.target.value)}
        />
      </Form.Group>
      <br />
      <Form.Group controlId="formCurrencyName">
        <Form.Label>Currency Name</Form.Label>
        <Form.Control
          size="lg"
          aria-label="Currency Name"
          onChange={(e) => setCurrencyName(e.target.value)}
        />
      </Form.Group>
    </Form>
  );

  return (
    <div className={"container"}>
      <h2 className="title">Currencies</h2>
      <div className={"currency-button"}>
        <Button variant="danger" onClick={handleOpenModal}>
          Create a New Currency
        </Button>
      </div>
      <Table bordered hover>
        <thead>
          <tr>
            <th>Currency Code</th>
            <th>Currency Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currencies.map((currency, index) => (
            <tr key={`c-${index}`}>
              <td key={`cc-${index}`}>{currency.CurrencyCode}</td>
              <td key={`cn-${index}`}>{currency.CurrencyName}</td>
              <td key={`d-${index}`} className={"icon-row"}>
                <button
                  name="delete"
                  className={"icon-button"}
                  onClick={() => {
                    setCurrencyToDelete({
                      id: currency.id,
                      CurrencyName: currency.CurrencyName,
                    });
                    handleOpenDeleteModal();
                  }}
                >
                  <FaTrash color={color.red} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal
        enableModal={enableModal}
        handleClose={handleCloseModal}
        handleSubmit={postCurrencies}
        title="Create a New Currency"
        closeButtonText="Close"
        actionButtonText="Save"
      >
        {renderCurrencyInput()}
      </Modal>
      <Modal
        enableModal={enableDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleSubmit={handleDelete}
        title={"Delete Currency"}
        closeButtonText="Close"
        actionButtonText="Delete"
      >
        Are you sure that you want to delete {currencyToDelete.CurrencyName}?
      </Modal>
    </div>
  );
}
